import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {InputTextData} from "../../interfaces/input-text-data";

@Component({
  selector: 'brt-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss']
})
export class InputTextComponent {

  @Input("data") data!: InputTextData;
  @Output('onValueChange') onValueChange = new EventEmitter<string>();
  @Input('isRequired') isRequired = false;

  onChange($event: KeyboardEvent) {
    const target = $event.target as HTMLInputElement;
    this.onValueChange.emit(target.value);
  }
}
